import { render, staticRenderFns } from "./Judges.vue?vue&type=template&id=cd6093a4&scoped=true&"
import script from "./Judges.vue?vue&type=script&lang=js&"
export * from "./Judges.vue?vue&type=script&lang=js&"
import style0 from "./Judges.vue?vue&type=style&index=0&id=cd6093a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6093a4",
  null
  
)

export default component.exports